export const labelKeys = ['title', 'label', 'btnLabel', 'tpl', 'placeholder', 'confirmText', 'success', 'failed', 'tooltip', 'content', 'option', 'description']